<!--  -->
<template>
    <div class='bgc'>
        <p>拖动进行排序</p>
        <draggable v-model="list" animation="300" group="people" @start="drag = true" @end="drag = true">
            <el-checkbox :label="city.key" :key="city.key" border v-model="checkboxGroup" v-for="city, index in list"><i
                    class="el-icon-rank"></i> {{ city.value }}</el-checkbox>
        </draggable>
        <div class="row-item footer" style="width: 97%; margin-top: 10px; text-align: center">
            <div class="element-list jb-bg btn" @click="submit">导出仪器标签</div>
            <div class="element-list btn" @click="handleClear">取消</div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
export default {
    //import引入的组件需要注入到对象中才能使用
    components: { draggable },
    props: {
        labelArray: {
            type: Array,
            default: []
        },
        visible: {
            type: Boolean,
            default: false,
        },
        insIds: {
            type: Array,
            default: []
        },
    },
    data() {
        //这里存放数据
        return {
            list: [],
            checkboxGroup: []
        };
    },
    //监听属性 类似于data概念
    computed: {


    },
    //监控data中的数据变化
    watch: {
        labelArray: {
            immediate: true,
            deep: true,
            handler(value) {
                this.list = value
            }
        },
        visible: {
            immediate: true,
            deep: true,
            handler(value) {
                this.checkboxGroup = []
            }
        }

    },
    //方法集合
    methods: {
        submit() {
            if (!this.checkboxGroup || this.checkboxGroup.length == 0) {
                this.$message({
                    message: '请选择需要导出的标签',
                    type: 'warning'
                });
                return
            }
            this.$emit('submit', this.checkboxGroup)
        },
        handleClear() {
            this.$emit('closeLable')
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
.bgc {
    p {
        color: #74c8fe;
        margin-bottom: 10px;
    }

    /deep/ .el-checkbox {
        color: #74c8fe;
        min-width: 180px;
        margin-bottom: 20px;
        height: 40px;

    }

    /deep/ .el-button+.el-button,
    .el-checkbox.is-bordered+.el-checkbox.is-bordered {
        margin-left: 0px;
    }

    .footer {
        display: flex;
        justify-content: center;
        color: #74c8fe;

        .element-list {
            width: 150px;
            cursor: pointer;
            border: 2px solid #0090f0;
            border-radius: 6px;
            height: 30px;
            line-height: 30px;
            margin: 10px 0;
            margin-right: 10px;
            text-align: center;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/labelModel/index.vue